import { FC, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'

type LinkAccountHandlerProps = {
}
export const LinkAccountHandler: FC<LinkAccountHandlerProps> = (props) => {
  const { children } = props

  const dispatch = useStoreDispatch()
  const handleClick = useCallback(() => {
    dispatch(modifyFloatingPaneActionCreator('provider-search', {}))
  }, [dispatch])

  return (
    <span onClick={ handleClick }>
      { children }
    </span>
  )
}
